import React from 'react';
import { Button } from '@roger/ui-components';
import { useNavigate } from 'react-router-dom';
import X12_270_Testing from '../components/X12_270_Testing';

const TestingX12_270: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className='container mx-auto p-6 space-y-6'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center space-x-4'>
          <Button
            variant='outline'
            onClick={() => navigate('/testing')}
            className='flex items-center space-x-2'
          >
            <span>←</span>
            <span>Back to Testing</span>
          </Button>
          <div>
            <h1 className='text-3xl font-bold'>X12 270 Testing</h1>
            <p className='text-muted-foreground'>
              Generate X12 270 eligibility inquiry messages and submit to
              Waystar
            </p>
          </div>
        </div>
      </div>

      <X12_270_Testing />
    </div>
  );
};

export default TestingX12_270;
